import React, { useState } from 'react';

import CategoryTiles from './CategoryTiles';
import PolicyTiles from './PolicyTiles';
import SegmentedControl from './SegmentedControl';

const SECTION = { POLICY: 'policy', CATEGORIES: 'categories' };

/**
 * IB-701 — the Setup tab. A Policy | Categories segmented switch reveals one of two tile grids,
 * each wrapping the existing Policy / Category CRUD in a slide-over. Presentation only; no new
 * endpoints and no colour/governance data beyond what those models already store.
 */
const SetupTab = () => {
    const [section, setSection] = useState(SECTION.POLICY);

    return (
        <div className="tw-flex tw-flex-col tw-gap-5">
            <SegmentedControl
                value={section}
                onChange={setSection}
                options={[
                    { value: SECTION.POLICY, label: $t('Policy') },
                    { value: SECTION.CATEGORIES, label: $t('Categories') },
                ]}
            />

            {section === SECTION.POLICY ? <PolicyTiles /> : <CategoryTiles />}
        </div>
    );
};

export default SetupTab;
